/* eslint-disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.3.0 (NJsonSchema v10.1.5.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

/** Response model containing the information for one civil state item. */
export class CivilStateItem implements ICivilStateItem {
    /** The code of the civil state. */
    readonly code?: number;
    /** The name of the civil state. */
    readonly name?: string | undefined;

    constructor(data?: ICivilStateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).code = _data["code"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): CivilStateItem {
        data = typeof data === 'object' ? data : {};
        let result = new CivilStateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

/** Response model containing the information for one civil state item. */
export interface ICivilStateItem {
    /** The code of the civil state. */
    code?: number;
    /** The name of the civil state. */
    name?: string | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the CIVIL STATES processing. */
export class CivilStateGetResponse implements ICivilStateGetResponse {
    /** The list of all civil states after conversion. */
    readonly civilStates?: CivilStateItem[] | undefined;

    constructor(data?: ICivilStateGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["civilStates"])) {
                (<any>this).civilStates = [] as any;
                for (let item of _data["civilStates"])
                    (<any>this).civilStates!.push(CivilStateItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CivilStateGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CivilStateGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.civilStates)) {
            data["civilStates"] = [];
            for (let item of this.civilStates)
                data["civilStates"].push(item.toJSON());
        }
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the CIVIL STATES processing. */
export interface ICivilStateGetResponse {
    /** The list of all civil states after conversion. */
    civilStates?: CivilStateItem[] | undefined;
}

/** 100 - Continue, 101 - SwitchingProtocols, 102 - Processing, 103 - EarlyHints, 200 - OK, 201 - Created, 202 - Accepted, 203 - NonAuthoritativeInformation, 204 - NoContent, 205 - ResetContent, 206 - PartialContent, 207 - MultiStatus, 208 - AlreadyReported, 226 - IMUsed, 300 - Ambiguous, 301 - Moved, 302 - Redirect, 303 - RedirectMethod, 304 - NotModified, 305 - UseProxy, 306 - Unused, 307 - TemporaryRedirect, 308 - PermanentRedirect, 400 - BadRequest, 401 - Unauthorized, 402 - PaymentRequired, 403 - Forbidden, 404 - NotFound, 405 - MethodNotAllowed, 406 - NotAcceptable, 407 - ProxyAuthenticationRequired, 408 - RequestTimeout, 409 - Conflict, 410 - Gone, 411 - LengthRequired, 412 - PreconditionFailed, 413 - RequestEntityTooLarge, 414 - RequestUriTooLong, 415 - UnsupportedMediaType, 416 - RequestedRangeNotSatisfiable, 417 - ExpectationFailed, 421 - MisdirectedRequest, 422 - UnprocessableEntity, 423 - Locked, 424 - FailedDependency, 426 - UpgradeRequired, 428 - PreconditionRequired, 429 - TooManyRequests, 431 - RequestHeaderFieldsTooLarge, 451 - UnavailableForLegalReasons, 500 - InternalServerError, 501 - NotImplemented, 502 - BadGateway, 503 - ServiceUnavailable, 504 - GatewayTimeout, 505 - HttpVersionNotSupported, 506 - VariantAlsoNegotiates, 507 - InsufficientStorage, 508 - LoopDetected, 510 - NotExtended, 511 - NetworkAuthenticationRequired */
export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 301,
    MovedPermanently = 302,
    Moved = 303,
    Found = 304,
    Redirect = 305,
    SeeOther = 306,
    RedirectMethod = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    TemporaryRedirect = 402,
    RedirectKeepVerb = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    Locked = 431,
    FailedDependency = 451,
    UpgradeRequired = 500,
    PreconditionRequired = 501,
    TooManyRequests = 502,
    RequestHeaderFieldsTooLarge = 503,
    UnavailableForLegalReasons = 504,
    InternalServerError = 505,
    NotImplemented = 506,
    BadGateway = 507,
    ServiceUnavailable = 508,
    GatewayTimeout = 510,
    HttpVersionNotSupported = 511,
}

/** 1 - Info, 2 - Warning, 3 - Error, 4 - Confreq */
export enum MessageType {
    Info = 1,
    Warning = 2,
    Error = 3,
    Confreq = 4,
}

export class MessageDetail implements IMessageDetail {
    readonly type?: MessageType;
    readonly code?: string | undefined;
    readonly text?: string | undefined;
    readonly debugText?: string | undefined;
    readonly target?: string | undefined;
    readonly details?: MessageDetail[] | undefined;

    constructor(data?: IMessageDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            (<any>this).code = _data["code"];
            (<any>this).text = _data["text"];
            (<any>this).debugText = _data["debugText"];
            (<any>this).target = _data["target"];
            if (Array.isArray(_data["details"])) {
                (<any>this).details = [] as any;
                for (let item of _data["details"])
                    (<any>this).details!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["text"] = this.text;
        data["debugText"] = this.debugText;
        data["target"] = this.target;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageDetail {
    type?: MessageType;
    code?: string | undefined;
    text?: string | undefined;
    debugText?: string | undefined;
    target?: string | undefined;
    details?: MessageDetail[] | undefined;
}

export class ResponseEnvelopeOfCivilStateGetResponse implements IResponseEnvelopeOfCivilStateGetResponse {
    readonly data?: CivilStateGetResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfCivilStateGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? CivilStateGetResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfCivilStateGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfCivilStateGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfCivilStateGetResponse {
    data?: CivilStateGetResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing the information for one country item. */
export class CountryItem implements ICountryItem {
    /** The ISO 3 notation of the country. */
    readonly iso3?: string | undefined;
    /** The name of the country. */
    readonly name?: string | undefined;

    constructor(data?: ICountryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).iso3 = _data["iso3"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): CountryItem {
        data = typeof data === 'object' ? data : {};
        let result = new CountryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iso3"] = this.iso3;
        data["name"] = this.name;
        return data;
    }
}

/** Response model containing the information for one country item. */
export interface ICountryItem {
    /** The ISO 3 notation of the country. */
    iso3?: string | undefined;
    /** The name of the country. */
    name?: string | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the COUNTRIES processing. */
export class CountryGetResponse implements ICountryGetResponse {
    /** The list of all countries after conversion. */
    readonly countries?: CountryItem[] | undefined;

    constructor(data?: ICountryGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                (<any>this).countries = [] as any;
                for (let item of _data["countries"])
                    (<any>this).countries!.push(CountryItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the COUNTRIES processing. */
export interface ICountryGetResponse {
    /** The list of all countries after conversion. */
    countries?: CountryItem[] | undefined;
}

export class ResponseEnvelopeOfCountryGetResponse implements IResponseEnvelopeOfCountryGetResponse {
    readonly data?: CountryGetResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfCountryGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? CountryGetResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfCountryGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfCountryGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfCountryGetResponse {
    data?: CountryGetResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing the information for one driver license item. */
export class DriverLicenseItem implements IDriverLicenseItem {
    /** The code of the driver license. */
    readonly code?: string | undefined;
    /** The name of the driver license. */
    readonly name?: string | undefined;

    constructor(data?: IDriverLicenseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).code = _data["code"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): DriverLicenseItem {
        data = typeof data === 'object' ? data : {};
        let result = new DriverLicenseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

/** Response model containing the information for one driver license item. */
export interface IDriverLicenseItem {
    /** The code of the driver license. */
    code?: string | undefined;
    /** The name of the driver license. */
    name?: string | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the DRIVER LICENSES processing. */
export class DriverLicenseGetResponse implements IDriverLicenseGetResponse {
    /** The list of all driver licenses after conversion. */
    readonly driverLicenses?: DriverLicenseItem[] | undefined;

    constructor(data?: IDriverLicenseGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["driverLicenses"])) {
                (<any>this).driverLicenses = [] as any;
                for (let item of _data["driverLicenses"])
                    (<any>this).driverLicenses!.push(DriverLicenseItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DriverLicenseGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DriverLicenseGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.driverLicenses)) {
            data["driverLicenses"] = [];
            for (let item of this.driverLicenses)
                data["driverLicenses"].push(item.toJSON());
        }
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the DRIVER LICENSES processing. */
export interface IDriverLicenseGetResponse {
    /** The list of all driver licenses after conversion. */
    driverLicenses?: DriverLicenseItem[] | undefined;
}

export class ResponseEnvelopeOfDriverLicenseGetResponse implements IResponseEnvelopeOfDriverLicenseGetResponse {
    readonly data?: DriverLicenseGetResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfDriverLicenseGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? DriverLicenseGetResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfDriverLicenseGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfDriverLicenseGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfDriverLicenseGetResponse {
    data?: DriverLicenseGetResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing the information for one education level item. */
export class EducationLevelItem implements IEducationLevelItem {
    /** The code of the education level. */
    readonly code?: number;
    /** The name of the education level. */
    readonly name?: string | undefined;

    constructor(data?: IEducationLevelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).code = _data["code"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): EducationLevelItem {
        data = typeof data === 'object' ? data : {};
        let result = new EducationLevelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

/** Response model containing the information for one education level item. */
export interface IEducationLevelItem {
    /** The code of the education level. */
    code?: number;
    /** The name of the education level. */
    name?: string | undefined;
}

/** Response data for get education levels */
export class EducationLevelGetResponse implements IEducationLevelGetResponse {
    /** The list of all education levels after conversion. */
    readonly educationLevels?: EducationLevelItem[] | undefined;

    constructor(data?: IEducationLevelGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["educationLevels"])) {
                (<any>this).educationLevels = [] as any;
                for (let item of _data["educationLevels"])
                    (<any>this).educationLevels!.push(EducationLevelItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EducationLevelGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EducationLevelGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.educationLevels)) {
            data["educationLevels"] = [];
            for (let item of this.educationLevels)
                data["educationLevels"].push(item.toJSON());
        }
        return data;
    }
}

/** Response data for get education levels */
export interface IEducationLevelGetResponse {
    /** The list of all education levels after conversion. */
    educationLevels?: EducationLevelItem[] | undefined;
}

export class ResponseEnvelopeOfEducationLevelGetResponse implements IResponseEnvelopeOfEducationLevelGetResponse {
    readonly data?: EducationLevelGetResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfEducationLevelGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? EducationLevelGetResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfEducationLevelGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfEducationLevelGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfEducationLevelGetResponse {
    data?: EducationLevelGetResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing the information for one language item. */
export class LanguageItem implements ILanguageItem {
    /** The ISO 3 notation of the language. */
    readonly iso3?: string | undefined;
    /** The name of the language. */
    readonly name?: string | undefined;

    constructor(data?: ILanguageItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).iso3 = _data["iso3"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): LanguageItem {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iso3"] = this.iso3;
        data["name"] = this.name;
        return data;
    }
}

/** Response model containing the information for one language item. */
export interface ILanguageItem {
    /** The ISO 3 notation of the language. */
    iso3?: string | undefined;
    /** The name of the language. */
    name?: string | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the LANGUAGES processing. */
export class LanguageGetResponse implements ILanguageGetResponse {
    /** The list of all languages after conversion. */
    readonly languages?: LanguageItem[] | undefined;

    constructor(data?: ILanguageGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languages"])) {
                (<any>this).languages = [] as any;
                for (let item of _data["languages"])
                    (<any>this).languages!.push(LanguageItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the LANGUAGES processing. */
export interface ILanguageGetResponse {
    /** The list of all languages after conversion. */
    languages?: LanguageItem[] | undefined;
}

export class ResponseEnvelopeOfLanguageGetResponse implements IResponseEnvelopeOfLanguageGetResponse {
    readonly data?: LanguageGetResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfLanguageGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? LanguageGetResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfLanguageGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfLanguageGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfLanguageGetResponse {
    data?: LanguageGetResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Request model containing all of the data which needs to be provided as a SEND-VERIFICATION-CODE payload. */
export class PhoneSendVerificationCodeRequest implements IPhoneSendVerificationCodeRequest {
    /** Phone number provided. Phone number of the user. */
    phoneNumber!: string;
    /** Language provided. Language in ISO3 format. */
    lang!: string;

    constructor(data?: IPhoneSendVerificationCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): PhoneSendVerificationCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneSendVerificationCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["lang"] = this.lang;
        return data;
    }
}

/** Request model containing all of the data which needs to be provided as a SEND-VERIFICATION-CODE payload. */
export interface IPhoneSendVerificationCodeRequest {
    /** Phone number provided. Phone number of the user. */
    phoneNumber: string;
    /** Language provided. Language in ISO3 format. */
    lang: string;
}

/** Response model containing all of the data which needs to be provided as a result of the SEND-VERIFICATION-CODE processing. */
export class PhoneSendVerificationCodeResponse implements IPhoneSendVerificationCodeResponse {
    /** The boolean that indicates if the message could be sent to the phone number. */
    readonly success?: boolean;

    constructor(data?: IPhoneSendVerificationCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): PhoneSendVerificationCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneSendVerificationCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the SEND-VERIFICATION-CODE processing. */
export interface IPhoneSendVerificationCodeResponse {
    /** The boolean that indicates if the message could be sent to the phone number. */
    success?: boolean;
}

export class ResponseEnvelopeOfPhoneSendVerificationCodeResponse implements IResponseEnvelopeOfPhoneSendVerificationCodeResponse {
    readonly data?: PhoneSendVerificationCodeResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfPhoneSendVerificationCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? PhoneSendVerificationCodeResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfPhoneSendVerificationCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfPhoneSendVerificationCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfPhoneSendVerificationCodeResponse {
    data?: PhoneSendVerificationCodeResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Request model containing all of the data which needs to be provided as a VERIFY-VERIFICATION-CODE payload. */
export class PhoneVerifyVerificationCodeRequest implements IPhoneVerifyVerificationCodeRequest {
    /** Phone number provided. Phone number of the user. */
    phoneNumber!: string;
    /** Verification code provided. Verification code for certain phone number. */
    verificationCode!: string;

    constructor(data?: IPhoneVerifyVerificationCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): PhoneVerifyVerificationCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneVerifyVerificationCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["verificationCode"] = this.verificationCode;
        return data;
    }
}

/** Request model containing all of the data which needs to be provided as a VERIFY-VERIFICATION-CODE payload. */
export interface IPhoneVerifyVerificationCodeRequest {
    /** Phone number provided. Phone number of the user. */
    phoneNumber: string;
    /** Verification code provided. Verification code for certain phone number. */
    verificationCode: string;
}

/** Response model containing all of the data which needs to be provided as a result of the VERIFY-VERIFICATION-CODE processing. */
export class PhoneVerifyVerificationCodeResponse implements IPhoneVerifyVerificationCodeResponse {
    /** The boolean that indicates if the verification code could be used for this phone number. */
    readonly success?: boolean;

    constructor(data?: IPhoneVerifyVerificationCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): PhoneVerifyVerificationCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneVerifyVerificationCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the VERIFY-VERIFICATION-CODE processing. */
export interface IPhoneVerifyVerificationCodeResponse {
    /** The boolean that indicates if the verification code could be used for this phone number. */
    success?: boolean;
}

export class ResponseEnvelopeOfPhoneVerifyVerificationCodeResponse implements IResponseEnvelopeOfPhoneVerifyVerificationCodeResponse {
    readonly data?: PhoneVerifyVerificationCodeResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfPhoneVerifyVerificationCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? PhoneVerifyVerificationCodeResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfPhoneVerifyVerificationCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfPhoneVerifyVerificationCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfPhoneVerifyVerificationCodeResponse {
    data?: PhoneVerifyVerificationCodeResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response Data for Post Picture */
export class PicturePostResponse implements IPicturePostResponse {
    /** The name of the picture */
    pictureName?: string | undefined;

    constructor(data?: IPicturePostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pictureName = _data["pictureName"];
        }
    }

    static fromJS(data: any): PicturePostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PicturePostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureName"] = this.pictureName;
        return data;
    }
}

/** Response Data for Post Picture */
export interface IPicturePostResponse {
    /** The name of the picture */
    pictureName?: string | undefined;
}

export class ResponseEnvelopeOfPicturePostResponse implements IResponseEnvelopeOfPicturePostResponse {
    readonly data?: PicturePostResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfPicturePostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? PicturePostResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfPicturePostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfPicturePostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfPicturePostResponse {
    data?: PicturePostResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response Data for Put Picture */
export class PicturePutResponse implements IPicturePutResponse {
    /** The name of the picture */
    pictureName?: string | undefined;

    constructor(data?: IPicturePutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pictureName = _data["pictureName"];
        }
    }

    static fromJS(data: any): PicturePutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PicturePutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureName"] = this.pictureName;
        return data;
    }
}

/** Response Data for Put Picture */
export interface IPicturePutResponse {
    /** The name of the picture */
    pictureName?: string | undefined;
}

export class ResponseEnvelopeOfPicturePutResponse implements IResponseEnvelopeOfPicturePutResponse {
    readonly data?: PicturePutResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfPicturePutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? PicturePutResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfPicturePutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfPicturePutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfPicturePutResponse {
    data?: PicturePutResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

export class Stream implements IStream {
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canTimeout?: boolean;
    readonly canWrite?: boolean;
    readonly length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canTimeout = _data["canTimeout"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["canWrite"] = this.canWrite;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }
}

export interface IStream {
    canRead?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    canWrite?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;
}

export class IActionResult implements IIActionResult {

    constructor(data?: IIActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new IActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIActionResult {
}

export class AddressModel implements IAddressModel {
    street?: string | undefined;
    streetNumber?: string | undefined;
    streetBox?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.streetBox = _data["streetBox"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["streetBox"] = this.streetBox;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        return data;
    }
}

export interface IAddressModel {
    street?: string | undefined;
    streetNumber?: string | undefined;
    streetBox?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
}

export class CountryModel implements ICountryModel {
    id?: string | undefined;

    constructor(data?: ICountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICountryModel {
    id?: string | undefined;
}

export class Birthplace implements IBirthplace {
    country?: CountryModel | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;

    constructor(data?: IBirthplace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] ? CountryModel.fromJS(_data["country"]) : <any>undefined;
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): Birthplace {
        data = typeof data === 'object' ? data : {};
        let result = new Birthplace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        return data;
    }
}

export interface IBirthplace {
    country?: CountryModel | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
}

/** 1 - Single, 2 - Married, 3 - WidowOrWidower, 4 - Divorced, 5 - SeperatedLegally, 6 - SeperatedActually, 7 - CohabitLegally, 8 - CohabitActually */
export enum CivilState {
    Single = 1,
    Married = 2,
    WidowOrWidower = 3,
    Divorced = 4,
    SeperatedLegally = 5,
    SeperatedActually = 6,
    CohabitLegally = 7,
    CohabitActually = 8,
}

/** Response Data for Get Profile */
export class ProfileGetResponse implements IProfileGetResponse {
    /** First name of the logged in user */
    readonly firstName?: string | undefined;
    /** Last name of the logged in user */
    readonly lastName?: string | undefined;
    /** The official address of the logged in user */
    officialAddress?: AddressModel | undefined;
    /** The email address of the logged in user */
    emailAddress?: string | undefined;
    /** The phone number of the logged in user */
    phone?: string | undefined;
    /** The birth date of the logged in user */
    birthdate?: Date | undefined;
    /** The birth place of the logged in user */
    birthplace?: Birthplace | undefined;
    /** The civil state of the logged in user */
    civilState?: CivilState | undefined;
    /** The language of the logged in user */
    language?: string | undefined;
    /** The bool that describes if the profile is under contract */
    readonly underContract?: boolean | undefined;

    constructor(data?: IProfileGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).firstName = _data["firstName"];
            (<any>this).lastName = _data["lastName"];
            this.officialAddress = _data["officialAddress"] ? AddressModel.fromJS(_data["officialAddress"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.phone = _data["phone"];
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>undefined;
            this.birthplace = _data["birthplace"] ? Birthplace.fromJS(_data["birthplace"]) : <any>undefined;
            this.civilState = _data["civilState"];
            this.language = _data["language"];
            (<any>this).underContract = _data["underContract"];
        }
    }

    static fromJS(data: any): ProfileGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["officialAddress"] = this.officialAddress ? this.officialAddress.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["phone"] = this.phone;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["birthplace"] = this.birthplace ? this.birthplace.toJSON() : <any>undefined;
        data["civilState"] = this.civilState;
        data["language"] = this.language;
        data["underContract"] = this.underContract;
        return data;
    }
}

/** Response Data for Get Profile */
export interface IProfileGetResponse {
    /** First name of the logged in user */
    firstName?: string | undefined;
    /** Last name of the logged in user */
    lastName?: string | undefined;
    /** The official address of the logged in user */
    officialAddress?: AddressModel | undefined;
    /** The email address of the logged in user */
    emailAddress?: string | undefined;
    /** The phone number of the logged in user */
    phone?: string | undefined;
    /** The birth date of the logged in user */
    birthdate?: Date | undefined;
    /** The birth place of the logged in user */
    birthplace?: Birthplace | undefined;
    /** The civil state of the logged in user */
    civilState?: CivilState | undefined;
    /** The language of the logged in user */
    language?: string | undefined;
    /** The bool that describes if the profile is under contract */
    underContract?: boolean | undefined;
}

export class ResponseEnvelopeOfProfileGetResponse implements IResponseEnvelopeOfProfileGetResponse {
    readonly data?: ProfileGetResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfProfileGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ProfileGetResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfProfileGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfProfileGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfProfileGetResponse {
    data?: ProfileGetResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Request model containing all of the data which needs to be provided as a SYNC RESUME TO ACCOUNT PROFILE payload. */
export class ProfilePostRequest implements IProfilePostRequest {
    /** The identifier of the resume. */
    resumeId?: string;
    /** The bool that indicates if the personal data must be synced. */
    syncPersonalData?: boolean;

    constructor(data?: IProfilePostRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resumeId = _data["resumeId"];
            this.syncPersonalData = _data["syncPersonalData"];
        }
    }

    static fromJS(data: any): ProfilePostRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilePostRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resumeId"] = this.resumeId;
        data["syncPersonalData"] = this.syncPersonalData;
        return data;
    }
}

/** Request model containing all of the data which needs to be provided as a SYNC RESUME TO ACCOUNT PROFILE payload. */
export interface IProfilePostRequest {
    /** The identifier of the resume. */
    resumeId?: string;
    /** The bool that indicates if the personal data must be synced. */
    syncPersonalData?: boolean;
}

/** Response Data for POST PROFILE */
export class ProfilePostResponse implements IProfilePostResponse {
    /** The identifier of the resume that's been used to update the account profile */
    identifier?: string;

    constructor(data?: IProfilePostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): ProfilePostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilePostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }
}

/** Response Data for POST PROFILE */
export interface IProfilePostResponse {
    /** The identifier of the resume that's been used to update the account profile */
    identifier?: string;
}

export class ResponseEnvelopeOfProfilePostResponse implements IResponseEnvelopeOfProfilePostResponse {
    readonly data?: ProfilePostResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfProfilePostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ProfilePostResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfProfilePostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfProfilePostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfProfilePostResponse {
    data?: ProfilePostResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Model which containing all of the data for the template. */
export class Template implements ITemplate {
    /** The title of the resume. */
    title?: string | undefined;
    /** The type of the template which is chosen. */
    type?: string | undefined;
    /** The language of the template which is chosen. */
    language?: string | undefined;
    /** The bool that indicates if you need to include the soft skills. */
    includeWai?: boolean;
    /** The description of the holiday pictures. */
    holidayPictureDescription?: string | undefined;
  /** The Id of the template which is chosen. */
    templateId: string;
  /** The Id of the color scheme which is chosen. */
    templateColorSchemeId: string | null;

    constructor(data?: ITemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.type = _data["type"];
            this.language = _data["language"];
            this.includeWai = _data["includeWai"];
            this.holidayPictureDescription = _data["holidayPictureDescription"];
            this.templateId = _data["templateId"];
            this.templateColorSchemeId = _data["templateColorSchemeId"];

        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["type"] = this.type;
        data["language"] = this.language;
        data["includeWai"] = this.includeWai;
        data["holidayPictureDescription"] = this.holidayPictureDescription;
        data["templateId"] = this.templateId;
        data["templateColorSchemeId"] = this.templateColorSchemeId;
        return data;
    }
}

/** Model which containing all of the data for the template. */
export interface ITemplate {
    /** The title of the resume. */
    title?: string | undefined;
    /** The type of the template which is chosen. */
    type?: string | undefined;
    /** The language of the template which is chosen. */
    language?: string | undefined;
    /** The bool that indicates if you need to include the soft skills. */
    includeWai?: boolean;
    /** The description of the holiday pictures. */
    holidayPictureDescription?: string | undefined;
  /** The Id of the template which is chosen. */
    templateId: string;
  /** The Id of the color scheme which is chosen. */
    templateColorSchemeId: string | null;
}

/** Request model which containing all of the data for an general item (code = Generic). */
export class CodeValueItemOfString implements ICodeValueItemOfString {
    /** The code of the item. (Generic) */
    code?: string | undefined;
    /** The value of the item. */
    value?: string | undefined;

    constructor(data?: ICodeValueItemOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CodeValueItemOfString {
        data = typeof data === 'object' ? data : {};
        let result = new CodeValueItemOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        return data;
    }
}

/** Request model which containing all of the data for an general item (code = Generic). */
export interface ICodeValueItemOfString {
    /** The code of the item. (Generic) */
    code?: string | undefined;
    /** The value of the item. */
    value?: string | undefined;
}

/** Request model which containing all of the data for an general item (code = Generic). */
export class CodeValueItemOfInt32 implements ICodeValueItemOfInt32 {
    /** The code of the item. (Generic) */
    code?: number;
    /** The value of the item. */
    value?: string | undefined;
    /** The id of the item. (Generic) */
    id?: string;

    constructor(data?: ICodeValueItemOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CodeValueItemOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new CodeValueItemOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

/** Request model which containing all of the data for an general item (code = Generic). */
export interface ICodeValueItemOfInt32 {
    /** The code of the item. (Generic) */
    code?: number;
    /** The value of the item. */
    value?: string | undefined;
}

/** Model which containing all of the data for the personalia. */
export class Personalia implements IPersonalia {
    /** The first name of the person. */
    firstName?: string | undefined;
    /** The last name of the person. */
    lastName?: string | undefined;
    /** The name of the picture of the person. */
    pictureName?: string | undefined;
    /** The zipcode of the person. */
    zipCode?: string | undefined;
    /** The city of the person. */
    city?: string | undefined;
    /** The house number of the person. */
    houseNumber?: string | undefined;
    /** The bus number of the person. */
    busNumber?: string | undefined;
    /** The street of the person. */
    street?: string | undefined;
    /** The country of the person. */
    country!: CodeValueItemOfString;
    /** The birth day of the person. */
    birthDay?: string | undefined;
    /** The birth country of the person. */
    birthCountry!: CodeValueItemOfString;
    /** The phone number of the person. */
    phoneNumber?: string | undefined;
    /** The mail of the person. */
    mail?: string | undefined;
    /** The civil state of the person. */
    civilState!: CodeValueItemOfInt32;
    /** The about of the person. */
    about?: string | undefined;
    /** The driver license(s) of the person. */
    driverLicense?: string[] | undefined;
    /** The linkedIn of the person. */
    linkedIn!: string;

    constructor(data?: IPersonalia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.country = new CodeValueItemOfString();
            this.birthCountry = new CodeValueItemOfString();
            this.civilState = new CodeValueItemOfInt32();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.pictureName = _data["pictureName"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.houseNumber = _data["houseNumber"];
            this.busNumber = _data["busNumber"];
            this.street = _data["street"];
            this.country = _data["country"] ? CodeValueItemOfString.fromJS(_data["country"]) : new CodeValueItemOfString();
            this.birthDay = _data["birthDay"];
            this.birthCountry = _data["birthCountry"] ? CodeValueItemOfString.fromJS(_data["birthCountry"]) : new CodeValueItemOfString();
            this.phoneNumber = _data["phoneNumber"];
            this.mail = _data["mail"];
            this.civilState = _data["civilState"] ? CodeValueItemOfInt32.fromJS(_data["civilState"]) : new CodeValueItemOfInt32();
            this.about = _data["about"];
            if (Array.isArray(_data["driverLicense"])) {
                this.driverLicense = [] as any;
                for (let item of _data["driverLicense"])
                    this.driverLicense!.push(item);
            }
            this.linkedIn = _data["linkedIn"];
        }
    }

    static fromJS(data: any): Personalia {
        data = typeof data === 'object' ? data : {};
        let result = new Personalia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["pictureName"] = this.pictureName;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["houseNumber"] = this.houseNumber;
        data["busNumber"] = this.busNumber;
        data["street"] = this.street;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["birthDay"] = this.birthDay;
        data["birthCountry"] = this.birthCountry ? this.birthCountry.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["mail"] = this.mail;
        data["civilState"] = this.civilState ? this.civilState.toJSON() : <any>undefined;
        data["about"] = this.about;
        if (Array.isArray(this.driverLicense)) {
            data["driverLicense"] = [];
            for (let item of this.driverLicense)
                data["driverLicense"].push(item);
        }
        data["linkedIn"] = this.linkedIn;
        return data;
    }
}

/** Model which containing all of the data for the personalia. */
export interface IPersonalia {
    /** The first name of the person. */
    firstName?: string | undefined;
    /** The last name of the person. */
    lastName?: string | undefined;
    /** The name of the picture of the person. */
    pictureName?: string | undefined;
    /** The zipcode of the person. */
    zipCode?: string | undefined;
    /** The city of the person. */
    city?: string | undefined;
    /** The house number of the person. */
    houseNumber?: string | undefined;
    /** The bus number of the person. */
    busNumber?: string | undefined;
    /** The street of the person. */
    street?: string | undefined;
    /** The country of the person. */
    country: CodeValueItemOfString;
    /** The birth day of the person. */
    birthDay?: string | undefined;
    /** The birth country of the person. */
    birthCountry: CodeValueItemOfString;
    /** The phone number of the person. */
    phoneNumber?: string | undefined;
    /** The mail of the person. */
    mail?: string | undefined;
    /** The civil state of the person. */
    civilState: CodeValueItemOfInt32;
    /** The about of the person. */
    about?: string | undefined;
    /** The driver license(s) of the person. */
    driverLicense?: string[] | undefined;
    /** The linkedIn of the person. */
    linkedIn: string;
}

/** Model which containing all of the data for the experience. */
export class Experience implements IExperience {
    /** The from date of the experience. */
    from?: string | undefined;
    /** The until date of the experience. */
    until?: string | undefined;
    /** The function of the experience. */
    function?: string | undefined;
    /** The company of the experience. */
    company?: string | undefined;
    /** The description of the experience. */
    description?: string | undefined;
    /** The bool that indicates that it's the most relevant experience. */
    mostRelevant?: boolean;
    /** The bool that indicates if education is displayed in CV */
    isHidden?: boolean;

    constructor(data?: IExperience) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.until = _data["until"];
            this.function = _data["function"];
            this.company = _data["company"];
            this.description = _data["description"];
            this.mostRelevant = _data["mostRelevant"];
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any): Experience {
        data = typeof data === 'object' ? data : {};
        let result = new Experience();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["until"] = this.until;
        data["function"] = this.function;
        data["company"] = this.company;
        data["description"] = this.description;
        data["mostRelevant"] = this.mostRelevant;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

/** Model which containing all of the data for the experience. */
export interface IExperience {
    /** The from date of the experience. */
    from?: string | undefined;
    /** The until date of the experience. */
    until?: string | undefined;
    /** The function of the experience. */
    function?: string | undefined;
    /** The company of the experience. */
    company?: string | undefined;
    /** The description of the experience. */
    description?: string | undefined;
    /** The bool that indicates that it's the most relevant experience. */
    mostRelevant?: boolean;
    /** The bool that indicates if education is displayed in CV */
    isHidden?: boolean;
}

/** Model which containing all of the data for the education. */
export class Education implements IEducation {
    /** The from date of the education. */
    from?: string | undefined;
    /** The until date of the education. */
    until?: string | undefined;
    /** The title of the education. */
    title?: string | undefined;
    /** The school of the education. */
    school?: string | undefined;
    /** The bool that indicates that it's the most relevant education. */
    mostRelevant?: boolean;
    /** The bool that indicates if education is displayed in CV */
    isHidden?: boolean;

    constructor(data?: IEducation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.until = _data["until"];
            this.title = _data["title"];
            this.school = _data["school"];
            this.mostRelevant = _data["mostRelevant"];
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any): Education {
        data = typeof data === 'object' ? data : {};
        let result = new Education();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["until"] = this.until;
        data["title"] = this.title;
        data["school"] = this.school;
        data["mostRelevant"] = this.mostRelevant;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

/** Model which containing all of the data for the education. */
export interface IEducation {
    /** The from date of the education. */
    from?: string | undefined;
    /** The until date of the education. */
    until?: string | undefined;
    /** The title of the education. */
    title?: string | undefined;
    /** The school of the education. */
    school?: string | undefined;
    /** The bool that indicates if education is displayed in CV */
    isHidden?: boolean;
    /** The bool that indicates that it's the most relevant education. */
    mostRelevant?: boolean;
}

/** Model which containing all of the data for the certification. */
export class Certification implements ICertification {
    /** The from date of the certification. */
    from?: string | undefined;
    /** The until date of the certification. */
    until?: string | undefined;
    /** The title of the certification. */
    title?: string | undefined;
    /** The organisation of the certification. */
    organisation?: string | undefined;
    /** The bool that indicates that it's the most relevant certification. */
    mostRelevant?: boolean;

    constructor(data?: ICertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.until = _data["until"];
            this.title = _data["title"];
            this.organisation = _data["organisation"];
            this.mostRelevant = _data["mostRelevant"];
        }
    }

    static fromJS(data: any): Certification {
        data = typeof data === 'object' ? data : {};
        let result = new Certification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["until"] = this.until;
        data["title"] = this.title;
        data["organisation"] = this.organisation;
        data["mostRelevant"] = this.mostRelevant;
        return data;
    }
}

/** Model which containing all of the data for the certification. */
export interface ICertification {
    /** The from date of the certification. */
    from?: string | undefined;
    /** The until date of the certification. */
    until?: string | undefined;
    /** The title of the certification. */
    title?: string | undefined;
    /** The organisation of the certification. */
    organisation?: string | undefined;
    /** The bool that indicates that it's the most relevant certification. */
    mostRelevant?: boolean;
}

/** Model which containing all of the data for the language. */
export class Language implements ILanguage {
    /** The language information of the language. */
    languageInfo!: CodeValueItemOfString;
    /** The level of the language. */
    level?: number;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.languageInfo = new CodeValueItemOfString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageInfo = _data["languageInfo"] ? CodeValueItemOfString.fromJS(_data["languageInfo"]) : new CodeValueItemOfString();
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageInfo"] = this.languageInfo ? this.languageInfo.toJSON() : <any>undefined;
        data["level"] = this.level;
        return data;
    }
}

/** Model which containing all of the data for the language. */
export interface ILanguage {
    /** The language information of the language. */
    languageInfo: CodeValueItemOfString;
    /** The level of the language. */
    level?: number;
}

/** Model which containing all of the data for the question. */
export class Question implements IQuestion {
    /** The question information of the question. */
    questionInfo!: CodeValueItemOfString;
    /** The answer of the question. */
    answer?: string | undefined;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questionInfo = new CodeValueItemOfString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionInfo = _data["questionInfo"] ? CodeValueItemOfString.fromJS(_data["questionInfo"]) : new CodeValueItemOfString();
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionInfo"] = this.questionInfo ? this.questionInfo.toJSON() : <any>undefined;
        data["answer"] = this.answer;
        return data;
    }
}

/** Model which containing all of the data for the question. */
export interface IQuestion {
    /** The question information of the question. */
    questionInfo: CodeValueItemOfString;
    /** The answer of the question. */
    answer?: string | undefined;
}

/** Model which containing all of the data for the reference. */
export class Reference implements IReference {
    /** The company of the reference. */
    company?: string | undefined;
    /** The contact person of the reference. */
    contactPerson?: string | undefined;
    /** The phone number of the reference. */
    phoneNumber?: string | undefined;
    /** The mail of the reference. */
    mail?: string | undefined;
    /** The bool that indicates if you can contact the person. */
    canContact?: boolean;
    /** The bool that indicates that it's the most relevant reference. */
    mostRelevant?: boolean;

    constructor(data?: IReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.contactPerson = _data["contactPerson"];
            this.phoneNumber = _data["phoneNumber"];
            this.mail = _data["mail"];
            this.canContact = _data["canContact"];
            this.mostRelevant = _data["mostRelevant"];
        }
    }

    static fromJS(data: any): Reference {
        data = typeof data === 'object' ? data : {};
        let result = new Reference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["contactPerson"] = this.contactPerson;
        data["phoneNumber"] = this.phoneNumber;
        data["mail"] = this.mail;
        data["canContact"] = this.canContact;
        data["mostRelevant"] = this.mostRelevant;
        return data;
    }
}

/** Model which containing all of the data for the reference. */
export interface IReference {
    /** The company of the reference. */
    company?: string | undefined;
    /** The contact person of the reference. */
    contactPerson?: string | undefined;
    /** The phone number of the reference. */
    phoneNumber?: string | undefined;
    /** The mail of the reference. */
    mail?: string | undefined;
    /** The bool that indicates if you can contact the person. */
    canContact?: boolean;
    /** The bool that indicates that it's the most relevant reference. */
    mostRelevant?: boolean;
}

/** Request model containing all of the data which needs to be provided as a POST RESUME payload. */
export class ResumePostRequest implements IResumePostRequest {
    /** The template information. */
    template!: Template;
    /** The personal information. */
    personalia!: Personalia;
    /** The experiences information. */
    experiences!: Experience[];
    /** The educations information. */
    educations!: Education[];
    /** The certifications information. */
    certifications!: Certification[];
    /** The languages information. */
    languages!: Language[];
    /** The competences information. */
    competences!: string[];
    /** The hobbies information. */
    hobbies!: string[];
    /** The characteristics information. */
    characteristics!: string[];
    /** The questions information. */
    questions!: Question[];
    /** The references information. */
    references!: Reference[];
    /** The holiday pictures information. */
    holidayPictures!: string[];
    /** Is draft flag. */
    isDraft!: boolean;

    constructor(data?: IResumePostRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.template = new Template();
            this.personalia = new Personalia();
            this.experiences = [];
            this.educations = [];
            this.certifications = [];
            this.languages = [];
            this.competences = [];
            this.hobbies = [];
            this.characteristics = [];
            this.questions = [];
            this.references = [];
            this.holidayPictures = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? Template.fromJS(_data["template"]) : new Template();
            this.personalia = _data["personalia"] ? Personalia.fromJS(_data["personalia"]) : new Personalia();
            if (Array.isArray(_data["experiences"])) {
                this.experiences = [] as any;
                for (let item of _data["experiences"])
                    this.experiences!.push(Experience.fromJS(item));
            }
            if (Array.isArray(_data["educations"])) {
                this.educations = [] as any;
                for (let item of _data["educations"])
                    this.educations!.push(Education.fromJS(item));
            }
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(Certification.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(Language.fromJS(item));
            }
            if (Array.isArray(_data["competences"])) {
                this.competences = [] as any;
                for (let item of _data["competences"])
                    this.competences!.push(item);
            }
            if (Array.isArray(_data["hobbies"])) {
                this.hobbies = [] as any;
                for (let item of _data["hobbies"])
                    this.hobbies!.push(item);
            }
            if (Array.isArray(_data["characteristics"])) {
                this.characteristics = [] as any;
                for (let item of _data["characteristics"])
                    this.characteristics!.push(item);
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(Reference.fromJS(item));
            }
            if (Array.isArray(_data["holidayPictures"])) {
                this.holidayPictures = [] as any;
                for (let item of _data["holidayPictures"])
                    this.holidayPictures!.push(item);
            }
            this.isDraft = _data["isDraft"];
        }
    }

    static fromJS(data: any): ResumePostRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResumePostRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["personalia"] = this.personalia ? this.personalia.toJSON() : <any>undefined;
        if (Array.isArray(this.experiences)) {
            data["experiences"] = [];
            for (let item of this.experiences)
                data["experiences"].push(item.toJSON());
        }
        if (Array.isArray(this.educations)) {
            data["educations"] = [];
            for (let item of this.educations)
                data["educations"].push(item.toJSON());
        }
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item.toJSON());
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        if (Array.isArray(this.competences)) {
            data["competences"] = [];
            for (let item of this.competences)
                data["competences"].push(item);
        }
        if (Array.isArray(this.hobbies)) {
            data["hobbies"] = [];
            for (let item of this.hobbies)
                data["hobbies"].push(item);
        }
        if (Array.isArray(this.characteristics)) {
            data["characteristics"] = [];
            for (let item of this.characteristics)
                data["characteristics"].push(item);
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        if (Array.isArray(this.holidayPictures)) {
            data["holidayPictures"] = [];
            for (let item of this.holidayPictures)
                data["holidayPictures"].push(item);
        }
        data["isDraft"] = this.isDraft;
        return data;
    }
}

/** Request model containing all of the data which needs to be provided as a POST RESUME payload. */
export interface IResumePostRequest {
    /** The template information. */
    template: Template;
    /** The personal information. */
    personalia: Personalia;
    /** The experiences information. */
    experiences: Experience[];
    /** The educations information. */
    educations: Education[];
    /** The certifications information. */
    certifications: Certification[];
    /** The languages information. */
    languages: Language[];
    /** The competences information. */
    competences: string[];
    /** The hobbies information. */
    hobbies: string[];
    /** The characteristics information. */
    characteristics: string[];
    /** The questions information. */
    questions: Question[];
    /** The references information. */
    references: Reference[];
    /** The holiday pictures information. */
    holidayPictures: string[];
    /** Is draft flag. */
    isDraft: boolean;
}

/** Response Data for Post Resume */
export class ResumePostResponse implements IResumePostResponse {
    /** The identifier of the resume */
    identifier?: string;

    constructor(data?: IResumePostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): ResumePostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumePostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }
}

/** Response Data for Post Resume */
export interface IResumePostResponse {
    /** The identifier of the resume */
    identifier?: string;
}

export class ResponseEnvelopeOfResumePostResponse implements IResponseEnvelopeOfResumePostResponse {
    readonly data?: ResumePostResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumePostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumePostResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumePostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumePostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumePostResponse {
    data?: ResumePostResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Request model containing all of the data which needs to be provided as a DUPLICATE RESUME payload. */
export class ResumeDuplicateRequest implements IResumeDuplicateRequest {
    /** The title of the duplicated resume. */
    title?: string | undefined;

    constructor(data?: IResumeDuplicateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ResumeDuplicateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeDuplicateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    }
}

/** Request model containing all of the data which needs to be provided as a DUPLICATE RESUME payload. */
export interface IResumeDuplicateRequest {
    /** The title of the duplicated resume. */
    title?: string | undefined;
}

/** Response Data for Duplicate Resume */
export class ResumeDuplicateResponse implements IResumeDuplicateResponse {
    /** The identifier of the resume */
    identifier?: string;

    constructor(data?: IResumeDuplicateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): ResumeDuplicateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeDuplicateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }
}

/** Response Data for Duplicate Resume */
export interface IResumeDuplicateResponse {
    /** The identifier of the resume */
    identifier?: string;
}

export class ResponseEnvelopeOfResumeDuplicateResponse implements IResponseEnvelopeOfResumeDuplicateResponse {
    readonly data?: ResumeDuplicateResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumeDuplicateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumeDuplicateResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumeDuplicateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumeDuplicateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumeDuplicateResponse {
    data?: ResumeDuplicateResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response Data for Share Resume */
export class ResumeShareResponse implements IResumeShareResponse {
    /** The secret key of the resume entity. */
    secretKey?: string;

    constructor(data?: IResumeShareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretKey = _data["secretKey"];
        }
    }

    static fromJS(data: any): ResumeShareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeShareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretKey"] = this.secretKey;
        return data;
    }
}

/** Response Data for Share Resume */
export interface IResumeShareResponse {
    /** The secret key of the resume entity. */
    secretKey?: string;
}

export class ResponseEnvelopeOfResumeShareResponse implements IResponseEnvelopeOfResumeShareResponse {
    readonly data?: ResumeShareResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumeShareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumeShareResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumeShareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumeShareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumeShareResponse {
    data?: ResumeShareResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response Data for Unshare Resume */
export class ResumeUnshareResponse implements IResumeUnshareResponse {
    /** The identifier of the unshared resume. */
    readonly identifier?: string;

    constructor(data?: IResumeUnshareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): ResumeUnshareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeUnshareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }
}

/** Response Data for Unshare Resume */
export interface IResumeUnshareResponse {
    /** The identifier of the unshared resume. */
    identifier?: string;
}

export class ResponseEnvelopeOfResumeUnshareResponse implements IResponseEnvelopeOfResumeUnshareResponse {
    readonly data?: ResumeUnshareResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumeUnshareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumeUnshareResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumeUnshareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumeUnshareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumeUnshareResponse {
    data?: ResumeUnshareResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Request model containing all of the data which needs to be provided as a PUT RESUME payload. */
export class ResumePutRequest implements IResumePutRequest {
    /** The template information. */
    template!: Template;
    /** The personal information. */
    personalia!: Personalia;
    /** The experiences information. */
    experiences!: Experience[];
    /** The educations information. */
    educations!: Education[];
    /** The certifications information. */
    certifications!: Certification[];
    /** The languages information. */
    languages!: Language[];
    /** The competences information. */
    competences!: string[];
    /** The hobbies information. */
    hobbies!: string[];
    /** The characteristics information. */
    characteristics!: string[];
    /** The questions information. */
    questions!: Question[];
    /** The references information. */
    references!: Reference[];
    /** The holiday pictures information. */
    holidayPictures!: string[];
    /** Is draft flag. */
    isDraft!: boolean;

    constructor(data?: IResumePutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.template = new Template();
            this.personalia = new Personalia();
            this.experiences = [];
            this.educations = [];
            this.certifications = [];
            this.languages = [];
            this.competences = [];
            this.hobbies = [];
            this.characteristics = [];
            this.questions = [];
            this.references = [];
            this.holidayPictures = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? Template.fromJS(_data["template"]) : new Template();
            this.personalia = _data["personalia"] ? Personalia.fromJS(_data["personalia"]) : new Personalia();
            if (Array.isArray(_data["experiences"])) {
                this.experiences = [] as any;
                for (let item of _data["experiences"])
                    this.experiences!.push(Experience.fromJS(item));
            }
            if (Array.isArray(_data["educations"])) {
                this.educations = [] as any;
                for (let item of _data["educations"])
                    this.educations!.push(Education.fromJS(item));
            }
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(Certification.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(Language.fromJS(item));
            }
            if (Array.isArray(_data["competences"])) {
                this.competences = [] as any;
                for (let item of _data["competences"])
                    this.competences!.push(item);
            }
            if (Array.isArray(_data["hobbies"])) {
                this.hobbies = [] as any;
                for (let item of _data["hobbies"])
                    this.hobbies!.push(item);
            }
            if (Array.isArray(_data["characteristics"])) {
                this.characteristics = [] as any;
                for (let item of _data["characteristics"])
                    this.characteristics!.push(item);
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(Reference.fromJS(item));
            }

            if (Array.isArray(_data["holidayPictures"])) {
                this.holidayPictures = [] as any;
                for (let item of _data["holidayPictures"])
                    this.holidayPictures!.push(item);
            }
            this.isDraft = _data["isDraft"];
        }
    }

    static fromJS(data: any): ResumePutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResumePutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["personalia"] = this.personalia ? this.personalia.toJSON() : <any>undefined;
        if (Array.isArray(this.experiences)) {
            data["experiences"] = [];
            for (let item of this.experiences)
                data["experiences"].push(item.toJSON());
        }
        if (Array.isArray(this.educations)) {
            data["educations"] = [];
            for (let item of this.educations)
                data["educations"].push(item.toJSON());
        }
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item.toJSON());
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        if (Array.isArray(this.competences)) {
            data["competences"] = [];
            for (let item of this.competences)
                data["competences"].push(item);
        }
        if (Array.isArray(this.hobbies)) {
            data["hobbies"] = [];
            for (let item of this.hobbies)
                data["hobbies"].push(item);
        }
        if (Array.isArray(this.characteristics)) {
            data["characteristics"] = [];
            for (let item of this.characteristics)
                data["characteristics"].push(item);
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        if (Array.isArray(this.holidayPictures)) {
            data["holidayPictures"] = [];
            for (let item of this.holidayPictures)
                data["holidayPictures"].push(item);
        }
        data["isDraft"] = this.isDraft;
        return data;
    }
}

/** Request model containing all of the data which needs to be provided as a PUT RESUME payload. */
export interface IResumePutRequest {
    /** The template information. */
    template: Template;
    /** The personal information. */
    personalia: Personalia;
    /** The experiences information. */
    experiences: Experience[];
    /** The educations information. */
    educations: Education[];
    /** The certifications information. */
    certifications: Certification[];
    /** The languages information. */
    languages: Language[];
    /** The competences information. */
    competences: string[];
    /** The hobbies information. */
    hobbies: string[];
    /** The characteristics information. */
    characteristics: string[];
    /** The questions information. */
    questions: Question[];
    /** The references information. */
    references: Reference[];
    /** The holiday pictures information. */
    holidayPictures: string[];
    /** Is draft flag. */
    isDraft: boolean;
}

/** Response Data for Put Resume */
export class ResumePutResponse implements IResumePutResponse {
    /** The identifier of the resume */
    identifier?: string;

    constructor(data?: IResumePutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): ResumePutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumePutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }
}

/** Response Data for Put Resume */
export interface IResumePutResponse {
    /** The identifier of the resume */
    identifier?: string;
}

export class ResponseEnvelopeOfResumePutResponse implements IResponseEnvelopeOfResumePutResponse {
    readonly data?: ResumePutResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumePutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumePutResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumePutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumePutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumePutResponse {
    data?: ResumePutResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Model which containing all of the data for the template + identifier. */
export class TemplateWithId implements ITemplateWithId {
    /** The identifier of the template. */
    id?: string;
    /** The author of the template. */
    author?: string | undefined;
    /** The title of the resume. */
    title?: string | undefined;
    /** The type of the template which is chosen. */
    type?: string | undefined;
    /** The language of the template which is chosen. */
    language?: string | undefined;
    /** The bool that indicates if you need to include the soft skills. */
    includeWai?: boolean;
    /** The description of the holiday pictures. */
    holidayPictureDescription?: string | undefined;
  /** The Id of the template which is chosen. */
    templateId: string;
  /** The Id of the color scheme which is chosen. */
    templateColorSchemeId: string;

    constructor(data?: ITemplateWithId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.author = _data["author"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.language = _data["language"];
            this.includeWai = _data["includeWai"];
            this.holidayPictureDescription = _data["holidayPictureDescription"];
        }
    }

    static fromJS(data: any): TemplateWithId {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateWithId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["author"] = this.author;
        data["title"] = this.title;
        data["type"] = this.type;
        data["language"] = this.language;
        data["includeWai"] = this.includeWai;
        data["holidayPictureDescription"] = this.holidayPictureDescription;
        return data;
    }
}

/** Model which containing all of the data for the template + identifier. */
export interface ITemplateWithId {
    /** The identifier of the template. */
    id?: string;
    /** The author of the template. */
    author?: string | undefined;
    /** The title of the resume. */
    title?: string | undefined;
    /** The type of the template which is chosen. */
    type?: string | undefined;
    /** The language of the template which is chosen. */
    language?: string | undefined;
    /** The bool that indicates if you need to include the soft skills. */
    includeWai?: boolean;
    /** The description of the holiday pictures. */
    holidayPictureDescription?: string | undefined;
  /** The Id of the template which is chosen. */
    templateId: string;
  /** The Id of the color scheme which is chosen. */
    templateColorSchemeId: string;
}

/** Response model containing all of the data which needs to be provided as a result of the GET processing. */
export class ResumeGetResponse implements IResumeGetResponse {
    /** The template information. */
    template?: TemplateWithId | undefined;
    /** The personal information. */
    personalia?: Personalia | undefined;
    /** The experiences. */
    experiences?: Experience[] | undefined;
    /** The educations. */
    educations?: Education[] | undefined;
    /** The certifications. */
    certifications?: Certification[] | undefined;
    /** The languages. */
    languages?: Language[] | undefined;
    /** The competences. */
    competences?: string[] | undefined;
    /** The hobbies. */
    hobbies?: string[] | undefined;
    /** The characteristics. */
    characteristics?: string[] | undefined;
    /** The questions. */
    questions?: Question[] | undefined;
    /** The references. */
    references?: Reference[] | undefined;
    /** The holiday pictures. */
    holidayPictures?: string[] | undefined;
    /** Is draft flag. */
    isDraft?: boolean;

    constructor(data?: IResumeGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? TemplateWithId.fromJS(_data["template"]) : <any>undefined;
            this.personalia = _data["personalia"] ? Personalia.fromJS(_data["personalia"]) : <any>undefined;
            if (Array.isArray(_data["experiences"])) {
                this.experiences = [] as any;
                for (let item of _data["experiences"])
                    this.experiences!.push(Experience.fromJS(item));
            }
            if (Array.isArray(_data["educations"])) {
                this.educations = [] as any;
                for (let item of _data["educations"])
                    this.educations!.push(Education.fromJS(item));
            }
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(Certification.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(Language.fromJS(item));
            }
            if (Array.isArray(_data["competences"])) {
                this.competences = [] as any;
                for (let item of _data["competences"])
                    this.competences!.push(item);
            }
            if (Array.isArray(_data["hobbies"])) {
                this.hobbies = [] as any;
                for (let item of _data["hobbies"])
                    this.hobbies!.push(item);
            }
            if (Array.isArray(_data["characteristics"])) {
                this.characteristics = [] as any;
                for (let item of _data["characteristics"])
                    this.characteristics!.push(item);
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(Reference.fromJS(item));
            }
            if (Array.isArray(_data["holidayPictures"])) {
                this.holidayPictures = [] as any;
                for (let item of _data["holidayPictures"])
                    this.holidayPictures!.push(item);
            }
        }
    }

    static fromJS(data: any): ResumeGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["personalia"] = this.personalia ? this.personalia.toJSON() : <any>undefined;
        if (Array.isArray(this.experiences)) {
            data["experiences"] = [];
            for (let item of this.experiences)
                data["experiences"].push(item.toJSON());
        }
        if (Array.isArray(this.educations)) {
            data["educations"] = [];
            for (let item of this.educations)
                data["educations"].push(item.toJSON());
        }
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item.toJSON());
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        if (Array.isArray(this.competences)) {
            data["competences"] = [];
            for (let item of this.competences)
                data["competences"].push(item);
        }
        if (Array.isArray(this.hobbies)) {
            data["hobbies"] = [];
            for (let item of this.hobbies)
                data["hobbies"].push(item);
        }
        if (Array.isArray(this.characteristics)) {
            data["characteristics"] = [];
            for (let item of this.characteristics)
                data["characteristics"].push(item);
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        if (Array.isArray(this.holidayPictures)) {
            data["holidayPictures"] = [];
            for (let item of this.holidayPictures)
                data["holidayPictures"].push(item);
        }
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the GET processing. */
export interface IResumeGetResponse {
    /** The template information. */
    template?: TemplateWithId | undefined;
    /** The personal information. */
    personalia?: Personalia | undefined;
    /** The experiences. */
    experiences?: Experience[] | undefined;
    /** The educations. */
    educations?: Education[] | undefined;
    /** The certifications. */
    certifications?: Certification[] | undefined;
    /** The languages. */
    languages?: Language[] | undefined;
    /** The competences. */
    competences?: string[] | undefined;
    /** The hobbies. */
    hobbies?: string[] | undefined;
    /** The characteristics. */
    characteristics?: string[] | undefined;
    /** The questions. */
    questions?: Question[] | undefined;
    /** The references. */
    references?: Reference[] | undefined;
    /** The holiday pictures. */
    holidayPictures?: string[] | undefined;
}

export class ResponseEnvelopeOfResumeGetResponse implements IResponseEnvelopeOfResumeGetResponse {
    readonly data?: ResumeGetResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumeGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumeGetResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumeGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumeGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumeGetResponse {
    data?: ResumeGetResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response Data for Delete Resume */
export class ResumeRemoveResponse implements IResumeRemoveResponse {
    /** The identifier of the resume */
    identifier?: string;

    constructor(data?: IResumeRemoveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): ResumeRemoveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeRemoveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }
}

/** Response Data for Delete Resume */
export interface IResumeRemoveResponse {
    /** The identifier of the resume */
    identifier?: string;
}

export class ResponseEnvelopeOfResumeRemoveResponse implements IResponseEnvelopeOfResumeRemoveResponse {
    readonly data?: ResumeRemoveResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumeRemoveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumeRemoveResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumeRemoveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumeRemoveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumeRemoveResponse {
    data?: ResumeRemoveResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Model which containing if the template is rendered or not. */
export class TemplatePolling implements ITemplatePolling {
    /** The bool that indicates if the resume is rendered. */
    isRendered?: boolean;

    constructor(data?: ITemplatePolling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRendered = _data["isRendered"];
        }
    }

    static fromJS(data: any): TemplatePolling {
        data = typeof data === 'object' ? data : {};
        let result = new TemplatePolling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRendered"] = this.isRendered;
        return data;
    }
}

/** Model which containing if the template is rendered or not. */
export interface ITemplatePolling {
    /** The bool that indicates if the resume is rendered. */
    isRendered?: boolean;
}

/** Response model containing all of the data which needs to be provided as a result of the POLLING processing. */
export class ResumePollingResponse implements IResumePollingResponse {
    /** The template information. */
    template?: TemplatePolling | undefined;

    constructor(data?: IResumePollingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"] ? TemplatePolling.fromJS(_data["template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResumePollingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumePollingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the POLLING processing. */
export interface IResumePollingResponse {
    /** The template information. */
    template?: TemplatePolling | undefined;
}

export class ResponseEnvelopeOfResumePollingResponse implements IResponseEnvelopeOfResumePollingResponse {
    readonly data?: ResumePollingResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumePollingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumePollingResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumePollingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumePollingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumePollingResponse {
    data?: ResumePollingResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Model which containing all of the data detailed information for the template. */
export class TemplateDetail implements ITemplateDetail {
    /** The datetime which represents the creating of the template. */
    createdOn?: Date;
    /** The bool which says if the template is rendered. */
    isRendered?: boolean;
    /** The secret key of the resume entity. */
    secretKey?: string | undefined;
    /** The identifier of the template. */
    id?: string;
    /** The title of the resume. */
    title?: string | undefined;
    /** The type of the template which is chosen. */
    type?: string | undefined;
    /** The language of the template which is chosen. */
    language?: string | undefined;
    /** The bool that indicates to show or hide the action buttons for resume. */
    actions: {
        canUpdate: boolean,
        canDuplicate: boolean,
        canShare: boolean,
        canDownloadPdf: boolean,
        canDelete: boolean
    };

    constructor(data?: ITemplateDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.isRendered = _data["isRendered"];
            this.secretKey = _data["secretKey"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.language = _data["language"];
            this.actions = _data["actions"];
        }
    }

    static fromJS(data: any): TemplateDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["isRendered"] = this.isRendered;
        data["secretKey"] = this.secretKey;
        data["id"] = this.id;
        data["title"] = this.title;
        data["type"] = this.type;
        data["language"] = this.language;
        data["actions"] = this.actions;
        return data;
    }
}

/** Model which containing all of the data detailed information for the template. */
export interface ITemplateDetail {
    /** The datetime which represents the creating of the template. */
    createdOn?: Date;
    /** The bool which says if the template is rendered. */
    isRendered?: boolean;
    /** The secret key of the resume entity. */
    secretKey?: string | undefined;
    /** The identifier of the template. */
    id?: string;
    /** The author of the template. */
    author?: string | undefined;
    /** The title of the resume. */
    title?: string | undefined;
    /** The type of the template which is chosen. */
    type?: string | undefined;
    /** The language of the template which is chosen. */
    language?: string | undefined;
    /** The bool that indicates if you need to include the soft skills. */
    includeWai?: boolean;
    /** The description of the holiday pictures. */
    holidayPictureDescription?: string | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the GET ALL processing. */
export class ResumeGetAllResponse implements IResumeGetAllResponse {
    /** The templates information. */
    readonly templates?: TemplateDetail[] | undefined;

    constructor(data?: IResumeGetAllResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                (<any>this).templates = [] as any;
                for (let item of _data["templates"])
                    (<any>this).templates!.push(TemplateDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResumeGetAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeGetAllResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the GET ALL processing. */
export interface IResumeGetAllResponse {
    /** The templates information. */
    templates?: TemplateDetail[] | undefined;
}

export class ResponseEnvelopeOfResumeGetAllResponse implements IResponseEnvelopeOfResumeGetAllResponse {
    readonly data?: ResumeGetAllResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfResumeGetAllResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? ResumeGetAllResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfResumeGetAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfResumeGetAllResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfResumeGetAllResponse {
    data?: ResumeGetAllResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the EXISTS-WAI-SOFT SKILLS-ASSESSMENT processing. */
export class SoftSkillExistsWaiResponse implements ISoftSkillExistsWaiResponse {
    /** The boolean that indicates if the user has already a 'WAI' soft skill assessment. */
    readonly exists?: boolean;

    constructor(data?: ISoftSkillExistsWaiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).exists = _data["exists"];
        }
    }

    static fromJS(data: any): SoftSkillExistsWaiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SoftSkillExistsWaiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the EXISTS-WAI-SOFT SKILLS-ASSESSMENT processing. */
export interface ISoftSkillExistsWaiResponse {
    /** The boolean that indicates if the user has already a 'WAI' soft skill assessment. */
    exists?: boolean;
}

export class ResponseEnvelopeOfSoftSkillExistsWaiResponse implements IResponseEnvelopeOfSoftSkillExistsWaiResponse {
    readonly data?: SoftSkillExistsWaiResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfSoftSkillExistsWaiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? SoftSkillExistsWaiResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfSoftSkillExistsWaiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfSoftSkillExistsWaiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfSoftSkillExistsWaiResponse {
    data?: SoftSkillExistsWaiResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the TEMPLATES processing. */
export class TemplateGetAllResponse implements ITemplateGetAllResponse {
    /** The list of all names of the templates after conversion. */
    readonly templates?: string[] | undefined;

    constructor(data?: ITemplateGetAllResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                (<any>this).templates = [] as any;
                for (let item of _data["templates"])
                    (<any>this).templates!.push(item);
            }
        }
    }

    static fromJS(data: any): TemplateGetAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateGetAllResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item);
        }
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the TEMPLATES processing. */
export interface ITemplateGetAllResponse {
    /** The list of all names of the templates after conversion. */
    templates?: string[] | undefined;
}

export class ResponseEnvelopeOfTemplateGetAllResponse implements IResponseEnvelopeOfTemplateGetAllResponse {
    readonly data?: TemplateGetAllResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfTemplateGetAllResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? TemplateGetAllResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfTemplateGetAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfTemplateGetAllResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfTemplateGetAllResponse {
    data?: TemplateGetAllResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the TRANSLATIONS processing. */
export class TranslationGetResponse implements ITranslationGetResponse {
    /** The translations from the memory cache. */
    readonly translations?: { [key: string]: string; } | undefined;

    constructor(data?: ITranslationGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                (<any>this).translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this).translations![key] = _data["translations"][key];
                }
            }
        }
    }

    static fromJS(data: any): TranslationGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    data["translations"][key] = this.translations[key];
            }
        }
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the TRANSLATIONS processing. */
export interface ITranslationGetResponse {
    /** The translations from the memory cache. */
    translations?: { [key: string]: string; } | undefined;
}

export class ResponseEnvelopeOfTranslationGetResponse implements IResponseEnvelopeOfTranslationGetResponse {
    readonly data?: TranslationGetResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfTranslationGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? TranslationGetResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfTranslationGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfTranslationGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfTranslationGetResponse {
    data?: TranslationGetResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the TRIGGER processing. */
export class TranslationTriggerResponse implements ITranslationTriggerResponse {
    /** The bool that indicates if the new translations are triggered. */
    readonly triggered?: boolean;

    constructor(data?: ITranslationTriggerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).triggered = _data["triggered"];
        }
    }

    static fromJS(data: any): TranslationTriggerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationTriggerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["triggered"] = this.triggered;
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the TRIGGER processing. */
export interface ITranslationTriggerResponse {
    /** The bool that indicates if the new translations are triggered. */
    triggered?: boolean;
}

export class ResponseEnvelopeOfTranslationTriggerResponse implements IResponseEnvelopeOfTranslationTriggerResponse {
    readonly data?: TranslationTriggerResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfTranslationTriggerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? TranslationTriggerResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfTranslationTriggerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfTranslationTriggerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfTranslationTriggerResponse {
    data?: TranslationTriggerResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Request model containing all of the data which needs to be provided as a REGISTER-USER payload. */
export class UserRegisterRequest implements IUserRegisterRequest {
    /** The first name of the new user */
    firstName!: string;
    /** The last name of the new user */
    lastName!: string;
    /** The e-mail address of the new user */
    email!: string;
    /** The phone number of the new user */
    phone!: string;
    /** The password of the new user */
    password!: string;
    /** The verification code for phone number of the new user */
    verificationCode!: string;
    /** The ISO3 language code of the new user */
    language!: string;

    constructor(data?: IUserRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.password = _data["password"];
            this.verificationCode = _data["verificationCode"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UserRegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["password"] = this.password;
        data["verificationCode"] = this.verificationCode;
        data["language"] = this.language;
        return data;
    }
}

/** Request model containing all of the data which needs to be provided as a REGISTER-USER payload. */
export interface IUserRegisterRequest {
    /** The first name of the new user */
    firstName: string;
    /** The last name of the new user */
    lastName: string;
    /** The e-mail address of the new user */
    email: string;
    /** The phone number of the new user */
    phone: string;
    /** The password of the new user */
    password: string;
    /** The verification code for phone number of the new user */
    verificationCode: string;
    /** The ISO3 language code of the new user */
    language: string;
}

/** Response model containing all of the data which needs to be provided as a result of the REGISTER-USER processing. */
export class UserRegisterResponse implements IUserRegisterResponse {
    /** The user identifier name of the logged in user */
    userId?: string | undefined;

    constructor(data?: IUserRegisterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserRegisterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegisterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the REGISTER-USER processing. */
export interface IUserRegisterResponse {
    /** The user identifier name of the logged in user */
    userId?: string | undefined;
}

export class ResponseEnvelopeOfUserRegisterResponse implements IResponseEnvelopeOfUserRegisterResponse {
    readonly data?: UserRegisterResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfUserRegisterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? UserRegisterResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfUserRegisterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfUserRegisterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfUserRegisterResponse {
    data?: UserRegisterResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

/** Response model containing all of the data which needs to be provided as a result of the EXISTS-USER processing. */
export class UserExistsResponse implements IUserExistsResponse {
    /** The boolean that indicates if the user exists. */
    readonly exists?: boolean;

    constructor(data?: IUserExistsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).exists = _data["exists"];
        }
    }

    static fromJS(data: any): UserExistsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserExistsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        return data;
    }
}

/** Response model containing all of the data which needs to be provided as a result of the EXISTS-USER processing. */
export interface IUserExistsResponse {
    /** The boolean that indicates if the user exists. */
    exists?: boolean;
}

export class ResponseEnvelopeOfUserExistsResponse implements IResponseEnvelopeOfUserExistsResponse {
    readonly data?: UserExistsResponse | undefined;
    readonly statusCode?: HttpStatusCode;
    readonly ticketId?: string | undefined;
    readonly messages?: MessageDetail[] | undefined;

    constructor(data?: IResponseEnvelopeOfUserExistsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).data = _data["data"] ? UserExistsResponse.fromJS(_data["data"]) : <any>undefined;
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).ticketId = _data["ticketId"];
            if (Array.isArray(_data["messages"])) {
                (<any>this).messages = [] as any;
                for (let item of _data["messages"])
                    (<any>this).messages!.push(MessageDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseEnvelopeOfUserExistsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseEnvelopeOfUserExistsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["ticketId"] = this.ticketId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseEnvelopeOfUserExistsResponse {
    data?: UserExistsResponse | undefined;
    statusCode?: HttpStatusCode;
    ticketId?: string | undefined;
    messages?: MessageDetail[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
